import * as React from "react";
import { Link } from "react-router-dom";

import { Carousel, ProductListItem } from "..";
import { generateProductUrl, maybe } from "../../core/utils";
import { TypedFeaturedProductsQuery } from "./queries";
import { selectHomepageProducts } from "./selection";

import "./scss/index.scss";

interface ProductsFeaturedProps {
  title?: string;
}

const ProductsFeatured: React.FC<ProductsFeaturedProps> = ({ title }) => {
  return (
    <TypedFeaturedProductsQuery displayError={false}>
      {({ data }) => {
        const curatedProducts = maybe(
          () => data.shop.homepageCollection.products.edges,
          []
        );
        const newestProducts = maybe(() => data.products.edges, []);
        const selection = selectHomepageProducts(
          curatedProducts,
          newestProducts
        );

        if (selection.products.length) {
          return (
            <section
              aria-labelledby="homepage-products-heading"
              className="products-featured"
            >
              <div className="container">
                <h2 id="homepage-products-heading">
                  {selection.source === "curated" ? title : "New arrivals"}
                </h2>
                <Carousel>
                  {selection.products.map(({ node: product }) => (
                    <Link
                      to={generateProductUrl(product.id, product.name)}
                      key={product.id}
                    >
                      <ProductListItem product={product} />
                    </Link>
                  ))}
                </Carousel>
              </div>
            </section>
          );
        } else {
          return null;
        }
      }}
    </TypedFeaturedProductsQuery>
  );
};

ProductsFeatured.defaultProps = {
  title: "Featured",
};

export default ProductsFeatured;
